import {Component} from "react";
import React from "react";
import ZalesFooter from "./zales"
import KayFooter from "./kay"
import KayoutletFooter from "./kayoutlet"
import JaredFooter from "./jared"

class FooterSwitchComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {items: []}

    }

    componentDidMount() {
        fetch('/' + window.currentSite + '.footer.json')
            .then(response => {
                if (response.ok) {
                    return response.text()

                }
                else {
                    this.props.messages.show({
                        severity: 'error',
                        sticky: true,
                        summary: 'Error loading navbar data file: ',
                        detail: 'Cannot load data'
                    });
                    throw new Error('Something went wrong ...');
                }
            })
            .then(response => {
                try {
                    response = response.replace(new RegExp('url": "/', 'gi'), 'url": "' + window.baseSiteUrl + '/');
                    return JSON.parse(response);
                } catch (err) {
                    this.props.messages.show({
                        severity: 'error',
                        sticky: true,
                        summary: 'Error loading navbar data file: ',
                        detail: err.message
                    });
                }
            })
            .then(data => {
                for (var x in data ){
                    for (var x1 in data[x].items ){
                        var src1 ='www.'+ window.currentSite +'.com'
                        var dst1 = window.currentEnv+'.'+ window.currentSite +'.com'
                        if (window.currentEnv !== "prod")
                           data[x].items[x1].url =data[x].items[x1].url.replace(src1,dst1)
                        ////console.log('item',data[x].items[x1])
    
                    }
                    
                };
                this.setState({items: data})})
//            .then(data => this.setState({items: data}))
    }


    render() {
        let Component = null;
        if (this.state && this.state.items) {
            let footerComponents = {
                kay: KayFooter,
                kayoutlet: KayoutletFooter,
                zales: ZalesFooter,
                jared: JaredFooter
            };
            Component = footerComponents[window.currentSite];
        }

        return (
            <div>
                <Component model={this.state.items}/>
            </div>

        )
    }
}

export default FooterSwitchComponent



// WEBPACK FOOTER //
// ./src/site_interfaces/footers/footer_switch.js